<template>
    <div>
        <app-new-breadcrumb></app-new-breadcrumb>
        <div class="main">
            <div class="description">
                <div class="description-inner">
                <div class="description-text">
                    <h2>{{ $t("oldCurrencySavings") }}</h2>
                    <p>{{ $t("oldCurrencySavingsDescription") }}</p>
                </div>
                <div class="description-img">
                    <img src="https://resources.fia.ba/file/7DFA72DE-931E-EB11-8B7C-00155D1E1137.jpg">
                </div>
                </div>
            </div>
            <div class="main-part">
                <div class="page-inner">
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t("oldCurrencySavings") }}</h3>
                    </div>
                    <p v-html="$t('oldForeignCurrenySavinsLocations')"></p>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t("oldForeignCurrenySavinsDocumentTitle") }}</h3>
                    </div>
                    <p v-html="$t('oldForeignCurrenySavinsDocumentText')"></p>
                    <a href="https://resources.fia.ba/file/B61E81FE-3E20-EB11-8B7C-00155D1E1137.pdf" target="_blank"><div class="big-card-btn">{{ $t("oldForeignCurrenySavinsDocumentTitle") }}</div>
                </a>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t("legalBasis") }}</h3>
                    </div>
                    <p v-html="$t('legalBasisText')"></p>
                    <router-link
                        :to="{ name: 'contentNew', params: { id: 7249, slug: $t('oldCurrencySavingsLawRouteName') } }">
                        <div class="big-card-btn">{{ $t("link") }}</div>
                    </router-link>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t("newsTranslation") }}</h3>
                    </div>
                    <p v-html="$t('findNewsText')"></p>
                    <router-link
                        :to="{ name: 'contentNew', params: { id: 7296, slug: $t('oldCurrencySavingsNewsRouteName') } }">
                        <div class="big-card-btn">{{ $t("link") }}</div>
                    </router-link>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "../../common/Breadcrumb.vue";

export default {
    data() {
        return {
        }
    },
    components: {
        appNewBreadcrumb: Breadcrumb,
    },
}
</script>

<style scoped>
</style>
